"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jumpNethpMyDevice = exports.jumpOtherProgramOtherType = exports.jumpH5MiddlePage = exports.jumpOtherProgram = exports.jumpNethpInquiry = exports.jumpNethpHome = exports.isNethpMini = exports.isFamdocMini = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var miniprogramQuery_1 = require("./miniprogramQuery");
var searchParam_1 = require("./searchParam");
var wx_1 = require("./wx");
// 是否是家医小程序
var isFamdocMini = function () {
    return (js_cookie_1.default.get("miniprogram") == "famdoc" &&
        (0, miniprogramQuery_1.getMiniprogramParams)(false).get("miniprogram") === "famdoc");
};
exports.isFamdocMini = isFamdocMini;
// 判断是否互医小程序
var isNethpMini = function () {
    return (0, miniprogramQuery_1.getMiniprogramParams)(false).get("miniprogram") === "nethp";
};
exports.isNethpMini = isNethpMini;
var jumpNethpHome = function () { return __awaiter(void 0, void 0, void 0, function () {
    var wx;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(0, exports.isNethpMini)()) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, wx_1.getwx)()];
            case 1:
                wx = _a.sent();
                wx.miniProgram.switchTab({
                    url: "/pages/home/index",
                });
                return [2 /*return*/, true];
            case 2: return [2 /*return*/, false];
        }
    });
}); };
exports.jumpNethpHome = jumpNethpHome;
var jumpNethpInquiry = function () { return __awaiter(void 0, void 0, void 0, function () {
    var wx;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(0, exports.isNethpMini)()) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, wx_1.getwx)()];
            case 1:
                wx = _a.sent();
                wx.miniProgram.switchTab({
                    url: "/pages/myInquiry/index",
                });
                return [2 /*return*/, true];
            case 2: return [2 /*return*/, false];
        }
    });
}); };
exports.jumpNethpInquiry = jumpNethpInquiry;
var jumpHealthMiniConfig = function (options) {
    var type = options.type;
    var pageType = "h5";
    var path;
    var isLong = /^http(s)?/i;
    switch (+type) {
        case 1:
            if (isLong.test(options.url)) {
                // 支持CPS跟单，跳转京东健康小程序跟单中间页
                path = "/pages/proxy/union/union?spreadUrl=".concat(encodeURIComponent(options.url));
                pageType = "";
            }
            else {
                // 无CPS链接商品，跳转京东健康小程序商详页
                path = "/pages/product/product?wareId=".concat(options.wareId);
                pageType = "";
            }
            break;
        case 2:
            path = "/pages/searchlist/searchlist?name=".concat(options.name);
            pageType = "";
            break;
        case 3:
            path = encodeURIComponent("https://yao.jkcsjd.com/account/pharmacy/select?".concat((0, searchParam_1.searchParam)(options)));
            break;
        case 4:
            path = encodeURIComponent("https://yao.jkcsjd.com/account/cart?".concat((0, searchParam_1.searchParam)(options)));
            break;
        case 5:
            path = encodeURIComponent("https://yao.jkcsjd.com/account/order/detail?".concat((0, searchParam_1.searchParam)(options)));
            break;
    }
    return { pageType: pageType, path: path };
};
var jumpOtherProgram = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var wx, _a, pageType, path;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, wx_1.getwx)()];
            case 1:
                wx = _b.sent();
                if ((0, exports.isNethpMini)()) {
                    wx.miniProgram.navigateTo({
                        url: "/pages/jumpOtherProgram/index?".concat((0, searchParam_1.searchParam)(params)),
                    });
                    return [2 /*return*/, true];
                }
                else if ((0, exports.isFamdocMini)()) {
                    _a = jumpHealthMiniConfig(params), pageType = _a.pageType, path = _a.path;
                    wx.miniProgram.navigateTo({
                        url: "/pages/jumpOtherProgram/index?".concat((0, searchParam_1.searchParam)(__assign({ path: path, pageType: pageType, appId: "wx862d8e26109609cb", isJdLogin: 1 }, params))),
                    });
                }
                return [2 /*return*/];
        }
    });
}); };
exports.jumpOtherProgram = jumpOtherProgram;
var jumpH5MiddlePage = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var wx;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(0, exports.isNethpMini)()) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, wx_1.getwx)()];
            case 1:
                wx = _a.sent();
                wx.miniProgram.navigateTo({
                    url: "/pages/login/wv-common/wv-common?h5_url=".concat(encodeURIComponent(url)),
                });
                return [2 /*return*/, true];
            case 2: return [2 /*return*/];
        }
    });
}); };
exports.jumpH5MiddlePage = jumpH5MiddlePage;
// jumpOtherProgram中params的字段type为3时，修改小程序跳转方式以打通登录态
var jumpOtherProgramOtherType = function (params
// opts: any = {}
) { return __awaiter(void 0, void 0, void 0, function () {
    var wx, type, paramObj;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, wx_1.getwx)()];
            case 1:
                wx = _a.sent();
                if ((0, exports.isNethpMini)()) {
                    type = params.type;
                    paramObj = {
                        3: {
                            path: encodeURIComponent("https://yao.jkcsjd.com/account/pharmacy/select?".concat((0, searchParam_1.searchParam)(params))),
                            appId: "wx862d8e26109609cb",
                            pageType: "h5",
                        },
                    };
                    wx.miniProgram.navigateTo({
                        url: "/pages/login/transfer/transfer?".concat((0, searchParam_1.searchParam)(paramObj[type])),
                    });
                    return [2 /*return*/, true];
                }
                else if ((0, exports.isFamdocMini)()) {
                    (0, exports.jumpOtherProgram)(params);
                    // opts.isLogin = 1;
                    // opts.envVersion = 'trial';
                    // wx.miniProgram.navigateTo({
                    //   url: `/pages/jumpOtherProgram/index?${searchParam(opts)}`,
                    // });
                }
                return [2 /*return*/];
        }
    });
}); };
exports.jumpOtherProgramOtherType = jumpOtherProgramOtherType;
// 1 设备列表 2 我的设备
var jumpNethpMyDevice = function (patientId_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([patientId_1], args_1, true), void 0, function (patientId, backUrl, isList, deviceType, isPro) {
        var wx, returnPage;
        if (backUrl === void 0) { backUrl = encodeURIComponent(window.location.href); }
        if (isList === void 0) { isList = true; }
        if (deviceType === void 0) { deviceType = [1, 2, 5, 6, 7, 13, 15]; }
        if (isPro === void 0) { isPro = true; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, wx_1.getwx)()];
                case 1:
                    wx = _a.sent();
                    if ((0, exports.isNethpMini)()) {
                        returnPage = backUrl ? "AUTO" : "ChronicHome";
                        wx.miniProgram.redirectTo({
                            url: "/pages/myDevice/index?deviceType=".concat(encodeURIComponent(JSON.stringify(deviceType)), "&pid=").concat(patientId, "&path=").concat(isList ? 1 : 2, "&returnPage=").concat(returnPage, "&backUrl=").concat(backUrl).concat(isPro ? "" : "&env=pre"),
                        });
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/];
            }
        });
    });
};
exports.jumpNethpMyDevice = jumpNethpMyDevice;
